module.exports = __webpack_public_path__ + "img/chat-square-dots-fill.2e280e64.svg";